import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

interface IInputPattern {
    pattern: string;
    regexp: RegExp;
    name: string;
}
class InputPattern implements IInputPattern {
    pattern: string;
    regexp: RegExp;
    name: string;
    constructor(name: string, pattern: string) {
        this.name = name;
        this.pattern = pattern;
        this.regexp = new RegExp(pattern);
    }
}
@Directive({
    selector: '[respectPattern]'
})
export class RespectPatternDirective implements OnInit, OnDestroy {
    /** ##### PATTERNS ##### */
    /** Ricordarsi {0, MAX}*/
    static usernamePattern = new InputPattern('username', '^[a-zA-Z]{1}[a-zA-Z0-9-_\\.]{0,19}$');
    static emailPattern = new InputPattern('email', '^[a-zA-Z0-9\\-_\\.@]{0,200}$');
    static searchBarPattern = new InputPattern('searchbar', '^((?!,).)*$');
    static sigprovincePattern = new InputPattern('sigprov', '^[a-zA-Z]{0,2}$');
    static postalCodePattern = new InputPattern('postalcode', '^[0-9]{0,5}$');
    static pivaPattern = new InputPattern('piva', '^[0-9]{0,11}$');
    static fiscalCodePattern = new InputPattern(
        'fiscalcode',
        '(?:^[a-zA-Z]{0,6}$)|(?:^[a-zA-Z]{6}[0-9]{0,2}$)|(?:^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{0,1}$)|' +
            '(?:^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{0,2}$)|(?:^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{0,1}$)|' +
            '(?:^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{0,3}$)|(?:^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{0,1}$)'
    );
    static phonePattern = new InputPattern('phone', '^[+]?[0-9]{0,11}$');
    static podPattern = new InputPattern(
        'pod',
        '^(?:[iI]{1}[tT]{0,1})?(?:[iI]{1}[tT]{1}[0-9]{0,3})?(?:[iI]{1}[tT]{1}[0-9]{3}[eE]{0,1})?(?:[iI]{1}[tT]{1}[0-9]{3}[eE]{1}[0-9A-Za-z]{0,8})?$'
        //il lookbehind non è supportato da tutti i browswe
    );
    static pdrPattern = new InputPattern('pdr', '^[0-9]{0,14}$');
    static percentageFloat2Pattern = new InputPattern(
        'percentageFloat2',
        '^(?:(?:[1-9]{1}[0-9]{0,1}(?:\\.[0-9]{0,2})?)|0(?:\\.[0-9]{0,2})?|100(?:\\.[0-9]{0,2})?)$'
    );
    static alphanumeric20Pattern = new InputPattern('alphanumeric20', '^[a-zA-Z0-9]{0,20}$');
    static ibanPattern = new InputPattern(
        'iban',
        '(?:^[iI]{1}[tT]{0,1}$)|(?:^[iI]{1}[tT]{1}[0-9]{0,2}$)|(?:^[iI]{1}[tT]{1}[0-9]{2}[a-zA-Z]{0,1}$)|' +
            '(?:^[iI]{1}[tT]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{0,10}$)|(?:^[iI]{1}[tT]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{10}[0-9a-zA-Z]{0,12}$)'
    );
    static maxLength100 = new InputPattern('maxLength100', '^.{0,100}$');
    static remiPattern = new InputPattern('remi', '^[a-zA-Z0-9.-]{0,20}$');
    /** ##### end patterns ##### */

    @Input() patternToRespect: string;

    //constructor
    private sub: Subscription;
    constructor(private elem: ElementRef<HTMLInputElement>) {}

    //Ctrl combinations
    static allowCtrlCombination(event: KeyboardEvent, chr: string): boolean {
        return event.ctrlKey && event.key === chr;
    }
    static allowCtrlA(event: KeyboardEvent): boolean {
        return RespectPatternDirective.allowCtrlCombination(event, 'A');
    }
    static allowCtrlC(event: KeyboardEvent): boolean {
        return RespectPatternDirective.allowCtrlCombination(event, 'C');
    }
    static allowCtrlV(event: KeyboardEvent): boolean {
        return RespectPatternDirective.allowCtrlCombination(event, 'V');
    }
    static allowCtrlX(event: KeyboardEvent): boolean {
        return RespectPatternDirective.allowCtrlCombination(event, 'X');
    }
    static allowTab(event: KeyboardEvent) {
        return event.key === 'Tab' || event.key === 'TAB';
    }
    static allowCommonCtrlCombinations(event: KeyboardEvent) {
        return (
            RespectPatternDirective.allowCtrlA(event) ||
            RespectPatternDirective.allowCtrlC(event) ||
            RespectPatternDirective.allowCtrlX(event) ||
            RespectPatternDirective.allowCtrlV(event)
        );
    }

    static blockExceptSelectedPattern(event: KeyboardEvent, pattern: IInputPattern) {
        //allow tab and ctrl combinations
        if (
            RespectPatternDirective.allowTab(event) ||
            RespectPatternDirective.allowCommonCtrlCombinations(event)
        ) {
            return;
        }
        console.log(`RESPECT PATTERN ${pattern.name}=${pattern.pattern}`);
        //regexp check
        const value = (<HTMLInputElement>event.target).value;
        const newValue = value + event.key;
        const testPassed = pattern.regexp.test(newValue);
        /*console.log(`
      inputValue ='${value}'(length=${value.length})\n
      new inputValue='${newValue}'(length= ${newValue.length})\n
      regexp='${pattern.regexp}'\n
      testPassed='${testPassed}'.`);*/
        if (!testPassed) {
            // console.log("prevent default"); //dbg
            console.log('TEST NOT PASSED');
            event.preventDefault();
        }
        return;
    }

    ngOnDestroy(): void {
        if (this.sub != null) {
            this.sub.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.sub = fromEvent(this.elem.nativeElement, 'keypress')
            .pipe(tap((e: KeyboardEvent) => this.onKeyPress(e)))
            .subscribe();
    }

    // do not use @HostListener: it causes performance problems
    onKeyPress(event: KeyboardEvent) {
        switch (this.patternToRespect) {
            //username pattern
            case RespectPatternDirective.usernamePattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.usernamePattern
                );
            //searchbar pattern
            case RespectPatternDirective.searchBarPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.searchBarPattern
                );
            case RespectPatternDirective.emailPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.emailPattern
                );
            case RespectPatternDirective.sigprovincePattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.sigprovincePattern
                );
            case RespectPatternDirective.postalCodePattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.postalCodePattern
                );
            case RespectPatternDirective.pivaPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.pivaPattern
                );
            case RespectPatternDirective.fiscalCodePattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.fiscalCodePattern
                );
            case RespectPatternDirective.phonePattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.phonePattern
                );
            case RespectPatternDirective.podPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.podPattern
                );
            case RespectPatternDirective.pdrPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.pdrPattern
                );
            case RespectPatternDirective.percentageFloat2Pattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.percentageFloat2Pattern
                );
            case RespectPatternDirective.alphanumeric20Pattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.alphanumeric20Pattern
                );
            case RespectPatternDirective.ibanPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.ibanPattern
                );
            case RespectPatternDirective.maxLength100.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.maxLength100
                );
            case RespectPatternDirective.remiPattern.name:
                return RespectPatternDirective.blockExceptSelectedPattern(
                    event,
                    RespectPatternDirective.remiPattern
                );
            default:
                console.error(`UNRECOGNIZED PATTERN TO RESPECT '${this.patternToRespect}'`);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/respectPattern.directive.ts